import jQuery from 'jquery';

function TimepickerDirective() {
  return {
    restrict: 'A',
    require: '?ngModel',
    scope: {
      options: '=?'
    },
    link: (scope, element, attrs, ngModelCtrl) => {
      scope.options = scope.options || {};
      if (scope.options.parent) {
        scope.options.appendWidgetTo = scope.options.parent;
        delete scope.options.parent;
      }
      if (!('minuteStep' in scope.options)) scope.options.minuteStep = 15;
      if (!('showInputs' in scope.options)) scope.options.showInputs = false;
      if (!('disableFocus' in scope.options)) scope.options.disableFocus = true;
      if (!('defaultTime' in scope.options)) scope.options.defaultTime = false;

      element
        .timepicker(scope.options)
        .on('changeTime.timepicker', function () {
          const time = jQuery(this).val();

          ngModelCtrl.$setViewValue(time);
          ngModelCtrl.$dirty = true;

          if (scope.options && scope.options.eventHandlers && scope.options.eventHandlers.change) scope.options.eventHandlers.change();
        });

      if (attrs.placeholder) {
        jQuery(element).val(attrs.placeholder);
      }
    }
  };
}

TimepickerDirective.$inject = [];

export default TimepickerDirective;



// WEBPACK FOOTER //
// ./src/directives/timepicker.js